module.exports = __webpack_public_path__ + "static/media/S (83).2881539d.jpg";